﻿document.querySelectorAll('button[data-button-type="company-details"]').forEach(button => {
    button.addEventListener('click', event => {
        document.querySelector('#' + event.target.dataset.listid).classList.toggle('d-none');
    });
});